import React from 'react';
import { NavLink } from 'react-router-dom';
import withRouter from '../../../App/components/withRouter';
import { connect } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import OTPInput, { ResendOTP } from "otp-input-react";
import { Row, Col, Alert, Button } from 'reactstrap';
import queryString from "query-string";
import { portalLogoUrl } from '../../../helper/utils';
import { toast } from 'react-toastify';
import Aux from "../../../hoc/_Aux";

import { SEND_USER_MAIL_OTP, SET_LOGIN_AUTH_ERROR, SUBMIT_USER_OTP, SET_USER_LOGIN } from '../../../store/actions/auth';
import { GET_PROGRAM_DATA } from '../../../store/actions/dashboardAction';
import Auth from '../../../models/Auth';
import NoAccess from '../NoAccess';
import { PORTAL_INSTANCE } from '../../..';
import { FILTER_PERMISSION } from '../../../constants/client-permission';
import { SIDE_MENU_ITEMS } from '../../../App/layout/AdminLayout/Navigation';

const mapStateToProps = state => {
  return {
    loginData: state.auth.loginData,
    cognitoUser: state.auth.cognitoUser,
    username: state.auth.username,
    authLoginError: state.auth.authLoginError,
    programData: state.allRequest.programData
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    SEND_USER_MAIL_OTP: (payload) => dispatch(SEND_USER_MAIL_OTP(payload)),
    SUBMIT_USER_OTP: (payload) => dispatch(SUBMIT_USER_OTP(payload)),
    SET_USER_ERROR: (payload) => dispatch(SET_LOGIN_AUTH_ERROR(payload)),
    SET_USER_LOGIN: (payload) => dispatch(SET_USER_LOGIN(payload)),
    GET_PROGRAM_DATA: (payload) => dispatch(GET_PROGRAM_DATA(payload))
  }
}

class SignInOtp extends React.Component {

  constructor(props) {
    super(props);
    const params = queryString.parse(this.props.location.search)
    let { cId, pId } = PORTAL_INSTANCE
    this.state = {
      portalId: pId,
      clientId: cId,
      option: params.option,
      email: '',
      otp: '',
      isOtpEnabled: false,
      isOtpVisible: false,
      errMessage: '',
      isLoading: false,
      isTermsAndConditionsAccepted: false,
      remainingTime: 180
    }
  }

  params = queryString.parse(this.props.location.search)

  isScanQR = window.location.pathname.indexOf('/req-qr/login') > -1;
  isReqTmptId = this.params.rId ? Number.parseInt(this.params.rId) : 0;

  async componentDidMount() {
    this.setState({ isLoadingData: true })
    await this.props.GET_PROGRAM_DATA({ clientId: this.state.clientId, id: this.state.portalId, portalId: this.state.portalId })
    await this.redirectionUrl()
    this.setState({ isLoadingData: false })
  }

  async onLoginChanged(resendStatus) {
    this.props.SET_USER_ERROR(null)

    if (!this.state.email) {
      toast.error(`Please enter email`)
      this.setState({
        // errMessage: 'Please Enter Email',
        emilSuccess: ''
      })
      return;
    }

    let requestpayload = {
      email: this.state.email,
      portalId: this.state.portalId,
      clientId: this.state.clientId
    }
    if (!resendStatus) {
      this.setState({
        isLoading: true,
        otp: ''
      })
    }
    await this.props.SEND_USER_MAIL_OTP(requestpayload)
    this.setState({
      isLoading: false
    })
    if (this.props && this.props.authLoginError) {
      toast.error(`* You are not authorized user.Contact your Admin.`)
      // this.setState(
      //   {
      //     errMessage: '* You are not authorized user.Contact your Admin.'
      //   }
      // )
    } else {
      toast.error('* Your OTP is sent to your email successfully.')
      this.setState({
        isOtpVisible: true,
        errMessage: '',
        remainingTime: 180,
        // emilSuccess: '* Your OTP is sent to your email successfully.'
      })
      setTimeout(() => {
        this.setState({
          emilSuccess: ''
        })
      }, 60000);
    }

  }
  async onOTPLoginChanged() {
    this.props.SET_USER_ERROR(null)
    if (!this.state.isTermsAndConditionsAccepted) {
      toast.error('Please Accept Terms and Conditions.')
      this.setState({
        emilSuccess: '',
        // errMessage: 'Please Accept Terms and Conditions.'
      })
      return
    }
    if (!this.state.otp) {
      toast.error('Please Enter OTP.')
      this.setState({
        emilSuccess: '',
        // errMessage: 'Please Enter OTP.'
      })
      return
    }

    let requestpayload = {
      cognitoUser: this.props.cognitoUser,
      email: this.state.email || this.props.username,
      portalId: this.state.portalId,
      clientId: this.state.clientId,
      verifyCode: this.state.otp
    }
    this.setState({
      isLoading: true,
      errMessage: '',
      emilSuccess: ''
    })
    await this.props.SUBMIT_USER_OTP(requestpayload)
    this.setState({
      isLoading: false
    })
    if (this.props && this.props.authLoginError) {
      if (this.props.authLoginError === 'OTP expired, click on Resend OTP to generate new OTP.') {
        this.setState(
          {
            remainingTime: 1
          }
        )
      }
      toast.error(this.props.authLoginError)
      // this.setState({ errMessage: this.props.authLoginError })
    } else {
      if (this.props.loginData && this.props.loginData.userId) {
        let loginData = this.props.loginData
        loginData.portalId = this.state.portalId
        loginData.clientId = this.state.clientId
        this.redirectionUrl()
      }
    }
  }
  async redirectionUrl() {
    if (this.isScanQR && this.isReqTmptId) {
      if (this.props.programData.enableDefaultUserLogin) {
        if (this.state.option)
          await this.props.SET_USER_LOGIN({ portalId: this.state.portalId, clientId: this.state.clientId, username: "-1", password: "-1", option: this.state.option });
        else {
          this.setState({ isNoAccess: true });
          return;
        }
      }
      // enableOTPLogin
      if ((Auth.token && !Auth.isTokenExpired)) {
        this.props.navigate(`/dashboard/req-qr/${this.isReqTmptId}${this.props.location.search.indexOf("&option") > -1 ? this.props.location.search.slice(0, this.props.location.search.indexOf("&option")) : this.props.location.search}`);
      }
      if (this.props.location.search.indexOf("&option") > -1)
        this.props.history.replace(`/dashboard/req-qr/${this.isReqTmptId}${this.props.location.search.slice(0, this.props.location.search.indexOf("&option"))}`);
    } else {
      let menuItems = FILTER_PERMISSION(SIDE_MENU_ITEMS(), Auth.hasRightView, '')
      let firstPath = '/dashboard/home'
      if (menuItems?.length) {
          let pathItem = menuItems.find( ie => ie?.path?.startsWith('/')) 
          if (pathItem) {
              firstPath = pathItem.path
          }
      }
      this.props.navigate(`${firstPath}${this.props.location.search}`);
    }
  }

  onChangeInput = (event) => {
    this.setState({
      error: ''
    })
    const { name, value } = event.target

    this.setState({
      [name]: value,
      errMessage: '',
      emilSuccess: ''
    })
  }

  setOTP(otp) {
    this.setState({
      otp: otp
    })
  }

  render() {
    const { remainingTime } = this.state
    // const renderTime = () => React.Fragment;
    return (
      <Aux>
        <div className="auth-wrapper" style={{ fontFamily: '"Montserrat", sans-serif' }}>
          <img src={portalLogoUrl()} alt="Logo" className="login-bg" />
          <div className="auth-content">
            <div className="auth-bg">
              {/* <span className="r" />
              <span className="r s" />
              <span className="r s" />
              <span className="r" /> */}

            </div>
            {this.state.isLoadingData ? <div
              className="text-center font-weight-bold p-2 main-load-class bg-light"
              style={{ fontSize: "1.875rem", color: "#0478ae" }}
            >
              Loading...
            </div> : this.state.isNoAccess ? <NoAccess /> :
              <div className="card">
                {
                  !this.state.isOtpEnabled ?
                    <div className="card-body text-center">
                      <div className="mb-4">
                        {
                          this.props.selectedPortalLogo ? (
                            <img src={portalLogoUrl()} alt="Logo" height="6.25rem" width="9.375rem" />
                          ) : (<i className="feather icon-unlock auth-icon" />)
                        }
                      </div>

                      <h3 className="mb-4">Login</h3>
                      {this.state.errMessage ?
                        <Row>
                          <Col xl={{ size: 12 }}>
                            <Alert color="danger" className="text-center">{this.state.errMessage}</Alert>
                          </Col>
                        </Row> : null}
                      {this.state.emilSuccess ?
                        <Row>
                          <Col xl={{ size: 12 }}>
                            <Alert color="success" className="text-center">{this.state.emilSuccess}</Alert>
                          </Col>
                        </Row> : null}
                      <div className="input-group mb-3">
                        <input type="email" disabled={this.state.isOtpVisible} className="form-control" placeholder="Enter Email" id="inputEmail" name="email" value={this.state.email} required onChange={this.onChangeInput} onKeyDown={(e) => (e.keyCode === 13) ? this.onLoginChanged(true) : null} autoFocus />
                      </div>
                      {
                        this.state.isOtpVisible ?
                          <div>
                            <div className="input-group mb-3">
                              <input type="password" className="form-control" placeholder="Enter OTP" id="inputOtp" name="otp" maxLength="6" value={this.state.otp} required onChange={this.onChangeInput} autoFocus />
                            </div>
                            <div className="form-group text-start">
                              <div className="checkbox checkbox-fill d-inline">
                                <input type="checkbox" name="checkbox-fill-1" id="checkbox-fill-a1" checked={this.state.isTermsAndConditionsAccepted} onChange={() => { this.setState({ isTermsAndConditionsAccepted: !this.state.isTermsAndConditionsAccepted }) }} onKeyDown={(e) => (e.keyCode === 13) ? this.onOTPLoginChanged() : null} />
                                <label htmlFor="checkbox-fill-a1" className="cr1"> I accept <NavLink to={{ pathname: "https://www.sktes.com/data-privacy" }} target="_blank">Privacy Policy </NavLink> and <NavLink to={`/terms${this.props.location.search}`}>Terms </NavLink></label>
                              </div>
                            </div>
                            <Button color="primary" className="btn-block" size="lg" onClick={() => { this.onOTPLoginChanged() }} disabled={this.state.isLoading || this.props.session}>
                              <span style={{ "marginRight": "0.625rem" }} >
                                {this.state.isLoading ? (<FontAwesomeIcon icon={faSpinner} spin />) : null}
                              </span>
                              Login
                            </Button>
                            {
                              remainingTime === 1 ? <ResendOTP maxTime={1} style={{ paddingTop: '1.125rem' }} onResendClick={() => { this.onLoginChanged(true) }} /> : null
                            }
                            {
                              remainingTime !== 1 ? <ResendOTP maxTime={remainingTime} style={{ paddingTop: '1.125rem' }} onResendClick={() => { this.onLoginChanged(true) }} /> : null
                            }


                          </div> : null
                      }{
                        !this.state.isOtpVisible ?
                          <Button color="primary" className="btn-block" size="lg" onClick={() => { this.onLoginChanged(false) }} disabled={this.state.isLoading || this.props.session}>
                            <span style={{ "marginRight": "0.625rem" }} >
                              {this.state.isLoading ? (<FontAwesomeIcon icon={faSpinner} spin />) : null}
                            </span>
                            Request Login OTP
                          </Button> : null
                      }

                    </div> : null
                }
                {
                  this.state.isOtpEnabled ? <div className="card-body text-center">
                    <h3 className="mb-4">Enter Verification Code</h3>
                    <OTPInput
                      value={this.state.otp}
                      onChange={(e) => { this.setOTP(e) }}
                      autoFocus
                      OTPLength={6}
                      otpType="number"
                      disabled={false}
                      secure
                    />
                    <ResendOTP style={{ paddingTop: '1.125rem' }} handelResendClick={() => console.log("Resend clicked")} />
                    <Button color="primary" className="btn-block" size="lg" onClick={() => { this.onLoginChanged() }} disabled={this.state.isLoading || this.props.session}>
                      <span style={{ "marginRight": "0.625rem" }} >
                        {this.state.isLoading ? (<FontAwesomeIcon icon={faSpinner} spin />) : null}
                      </span>
                      Verify OTP
                    </Button>
                  </div> : null
                }

                <div className="card-footer">
                  {
                    this.state.error && (
                      <div className="alert alert-danger">{this.state.error} </div>
                    )
                  }
                  <div style={{ display: 'grid' }}>
                    <span>
                      Thank you for your interest in our services. To be able to login a one-time password (OTP) is required. To request it, please enter your email address into the entry field above. The one-time password will be sent to your email account.
                    </span>
                    <span style={{ marginTop: '1.25rem' }}>Best regards</span>
                    <span style={{ marginTop: '1.25rem' }}><b>Sk tes Customer Support</b></span>
                  </div>
                </div>

              </div>
            }
          </div>
        </div>
      </Aux>
    );
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SignInOtp));